function Footer() {
   return (
      <footer className="footer">
         <div className="social-connect">
            <p style={{ color: "white", margin: "0px" }}>Get in touch |</p>
            <ul className="footer_links">
               <li className="footer_link">
                  <a
                     href="https://www.linkedin.com/in/sunil-rawat-0059861ab/"
                     target="_blank"
                     rel="noreferrer"
                  >
                     <svg
                        id="linkedIn"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{ color: "white" }}
                        viewBox="0 0 24 24"
                        data-supported-dps="24x24"
                        fill="currentColor"
                        // class="mercado-match"
                        width="30"
                        height="30"
                        focusable="false"
                     >
                        <path d="M20.5 2h-17A1.5 1.5 0 002 3.5v17A1.5 1.5 0 003.5 22h17a1.5 1.5 0 001.5-1.5v-17A1.5 1.5 0 0020.5 2zM8 19H5v-9h3zM6.5 8.25A1.75 1.75 0 118.3 6.5a1.78 1.78 0 01-1.8 1.75zM19 19h-3v-4.74c0-1.42-.6-1.93-1.38-1.93A1.74 1.74 0 0013 14.19a.66.66 0 000 .14V19h-3v-9h2.9v1.3a3.11 3.11 0 012.7-1.4c1.55 0 3.36.86 3.36 3.66z"></path>
                     </svg>
                  </a>
               </li>
               <li className="footer_link">
                  <a
                     href="https://www.youtube.com/@learnwithpeter9626"
                     target="_blank"
                     rel="noreferrer"
                  >
                     <svg
                        id="youtube"
                        xmlns="http://www.w3.org/2000/svg"
                        width="33"
                        height="33"
                        viewBox="0,0,256,256"
                     >
                        <g
                           fill="#ffffff"
                           stroke="none"
                        
                        >
                           <g transform="scale(5.12,5.12)">
                              <path d="M44.89844,14.5c-0.39844,-2.19922 -2.29687,-3.80078 -4.5,-4.30078c-3.29687,-0.69922 -9.39844,-1.19922 -16,-1.19922c-6.59766,0 -12.79687,0.5 -16.09766,1.19922c-2.19922,0.5 -4.10156,2 -4.5,4.30078c-0.40234,2.5 -0.80078,6 -0.80078,10.5c0,4.5 0.39844,8 0.89844,10.5c0.40234,2.19922 2.30078,3.80078 4.5,4.30078c3.5,0.69922 9.5,1.19922 16.10156,1.19922c6.60156,0 12.60156,-0.5 16.10156,-1.19922c2.19922,-0.5 4.09766,-2 4.5,-4.30078c0.39844,-2.5 0.89844,-6.10156 1,-10.5c-0.20312,-4.5 -0.70312,-8 -1.20312,-10.5zM19,32v-14l12.19922,7z"></path>
                           </g>
                        </g>
                     </svg>
                  </a>
               </li>
            </ul>
         </div>
         <small className="designedBy">
            Designed by <h5 className="designedByText"> Sunil Rawat </h5>
         </small>
      </footer>
   );
}
export default Footer;
